const layout = () => import("../../internal/layout.vue");
const coletaVideo = () => import("./adm-coleta-video.vue");

const coletaVideoRoutes = {
  component: layout,
  children: [
    {
      path: "",
      name: "upload-coleta-video",
      meta: {
        title: "UPLOAD COLETA POR VIDEO",
        requiresAuth: true,
      },
      component: coletaVideo,
    },
  ],
};

export default coletaVideoRoutes;
